import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useCustomAppClient } from 'api/custom-client';
import type { ErrorType } from 'api/custom-client';
import type { GetPanelReplacementGridResponse } from 'api/models';
import type { ProblemDetails } from 'api/models';

export interface GetPanelReplacementGridParams {
  systemId: string;
  filterActive?: boolean;
}

export const getPanelReplacementGridQueryKey = (params: GetPanelReplacementGridParams) =>
  ['/articles/system', params.systemId, 'panel-replacement-grid', params.filterActive] as const;

export const useGetPanelReplacementGrid = (
  params: GetPanelReplacementGridParams,
  options?: { query?: Partial<UseQueryOptions<GetPanelReplacementGridResponse, ErrorType<ProblemDetails>>> }
) => {
  const getPanelReplacementGrid = useCustomAppClient<GetPanelReplacementGridResponse>();
  const queryFn = useCallback(
    ({ signal }: { signal?: AbortSignal }) =>
      getPanelReplacementGrid({
        url: `/articles/system/${params.systemId}/panel-replacement-grid`,
        method: 'GET',
        params: { filterActive: params.filterActive },
        signal
      }),
    [getPanelReplacementGrid, params.filterActive, params.systemId]
  );

  return useQuery({
    queryKey: getPanelReplacementGridQueryKey(params),
    queryFn,
    ...options?.query
  });
};
